import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Body, Drawer } from 'components/Shell/Shell'
import { Modal } from 'components/Modal/Modal'
import Portal from 'components/Portal/Portal'
import Toolbar from 'components/Table/Toolbar'
import DataRequestBlock from './DataRequestBlock'
import ReportsList from 'components/MyWorkQueue/ReportsList'
import AmendmentLauncher from 'components/MyRecords/AmendmentLauncher'
import { history } from '../../store'
import Markdown from 'components/Markdown/Markdown'
import { GET_DATA_REQUEST_WIZARDS, GET_MY_DATA_REQUESTS, GET_APP_SETTING_BY_NAME, GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM } from 'requests'
import ManageDrawer from './ManageDrawer'
import SlidingPanel from 'components/SlidingPanel/SlidingPanel'
import ConnectedCheckout from 'components/Checkout/Checkout'
import { setCartQuantity, setErrorToast } from '../../actions'
import { Spinner } from 'components/Loaders/Loaders'
import {
  calculateReceiptItemsTotal,
  calculateReceiptItemContainersTotal
} from 'utilities'
import './DataRequests.scss'

const DATA_REQUEST_PAGE_TITLE = process.env.DATA_REQUEST_PAGE_TITLE
const DATA_REQUEST_LABEL = process.env.DATA_REQUEST_LABEL
const DATA_REQUEST_DESCRIPTION = process.env.DATA_REQUEST_DESCRIPTION
const SHOPPING_CART = process.env.SHOPPING_CART

class DataRequests extends React.Component {
  state = {
    filter: '',
    activeDrawerProps: null,
    drawerTitleCache: '',
    drawerSubtitleCache: '',
    drawerType: null,
    drawerOpen: false,
    modalOpen: false,
    checkoutOpen: false,
    requests: []
  }
  componentDidMount = () => {
    this.getDataRequests()
  }
  getDataRequests = (updateManagementDrawer) => {
    new Promise((resolve, reject) => {
      GET_MY_DATA_REQUESTS(
        requests => {
          resolve(this.setState({ requests: requests }))
          if (updateManagementDrawer){
            const activeRequest = requests.find(x => x.DATA_REQUEST_ID === this.state.activeDrawerProps.id)
            if(activeRequest){
              this.startManagementDrawer(activeRequest, true)
            }
          }
        },
        err => {
          console.error(err)
          reject(err)
        }
      )
    })
  }
  closeDrawer = () => this.setState({ activeDrawerProps: null })
  clearFilter = () => this.setState({ filter: '' })
  startManagementDrawer = (dr, keepDrawerOpen) => {
    this.setState(state =>
      state.drawerType === 'manage' &&
      (state.activeDrawerProps &&
        state.activeDrawerProps.id === dr.DATA_REQUEST_ID &&
        state.drawerOpen) &&
        keepDrawerOpen !== true
        ? { drawerOpen: false }
        : {
            activeDrawerProps: {
              id: dr.DATA_REQUEST_ID,
              formDefinitionId: dr.FORM_DEFINITION_ID,
              nickname: dr.NAME_OVERRIDE,
              frequencyTypeId: dr.FREQUENCY_TYPE_ID,
              statusId: dr.STATUS_ID,
              canEdit: dr.ALLOW_EDIT_ONLINE_RO_YN,
              canPause: dr.PAUSE_ENABLED_RO_YN,
              canUnpause: dr.UNPAUSE_ENABLED_RO_YN,
              canEditPayment: dr.ALLOW_EDIT_PAYMENT_RO_YN
            },
            drawerTitleCache: dr.NAME,
            drawerNicknameCache: dr.NAME_OVERRIDE,
            drawerSubtitleCache: dr.STATUS_RO,
            drawerType: 'manage',
            drawerOpen: true
          }
    )
  }
  startDownloadsDrawer = dr =>
    this.setState(state =>
      state.drawerType === 'downloads' &&
      (state.activeDrawerProps &&
        state.activeDrawerProps.id === dr.DATA_REQUEST_ID &&
        state.drawerOpen)
        ? { drawerOpen: false }
        : {
            activeDrawerProps: {
              id: dr.DATA_REQUEST_ID,
              formDefinitionId: dr.FORM_DEFINITION_ID,
              nickname: dr.NAME_OVERRIDE,
              frequencyTypeId: dr.FREQUENCY_TYPE_ID,
              statusId: dr.STATUS_ID,
              canEdit: dr.ALLOW_EDIT_ONLINE_RO_YN,
              canPause: dr.PAUSE_ENABLED_RO_YN,
              canUnpause: dr.UNPAUSE_ENABLED_RO_YN,
              canEditPayment: dr.ALLOW_EDIT_PAYMENT_RO_YN
            },
            drawerTitleCache: dr.NAME,
            drawerNicknameCache: dr.NAME_OVERRIDE,
            drawerSubtitleCache: dr.STATUS_RO,
            drawerType: 'downloads',
            drawerOpen: true
          }
    )
  getReceiptItems = (amendmentNum) => {
    return new Promise((resolve, reject) => {
      GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM(
        amendmentNum,
        'data-request',
        false,
        (receiptItems) => {
          resolve(receiptItems)
        },
        (error) => {
          reject(error)
          this.props.setErrorToast(error.message)
        }
      )
    })
  }
  startCheckout = (dr) => {
    let dataRequestItemId = dr.DATA_REQUEST_ITEM_LIST[0].DATA_REQUEST_ITEM_ID
    this.getReceiptItems(dataRequestItemId).then(
      ({ RECEIPT_ITEM_WEB_LIST, RECEIPT_ITEM_CONTAINER_WEB_LIST, REF_NUM }) => {
        const total = RECEIPT_ITEM_CONTAINER_WEB_LIST
          ? calculateReceiptItemContainersTotal(RECEIPT_ITEM_CONTAINER_WEB_LIST)
          : calculateReceiptItemsTotal(RECEIPT_ITEM_WEB_LIST)

        this.setState(
          {
            checkoutOpen: total > 0 ? true : false,
            checkoutDetails: {
              amendmentNum: dr.DATA_REQUEST_ID,
              receiptItems: RECEIPT_ITEM_WEB_LIST,
              receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
              refNum: REF_NUM,
            },
          },
          () => {
            if (SHOPPING_CART) {
              setCartQuantity(
                RECEIPT_ITEM_CONTAINER_WEB_LIST.filter((x) => !x.IS_FREE).length
              )
              this.getDataRequests(true)
            }
            if (total <= 0) {
              this.openReceipt()
            }
          }
        )
      }
    ).catch(error => {
      this.getDataRequests(false)
    })
  }
  closeCheckout = () => {
    console.log('closing')
    this.getDataRequests(true);
    this.setState({ checkoutOpen: false })
  }
  cancelCheckout = () => {
    console.log('cancelling')
    this.slider.closeSlider(() => {
      this.closeCheckout()
    })
  }
  openReceipt = (refNum) => {
    if (this.slider) {
      this.slider.closeSlider(() => {
        this.props.history.push(`/receipt?ref=${refNum || this.state.checkoutDetails.refNum}`)
      })
    } else {
      this.props.history.push(`/receipt?ref=${refNum || this.state.checkoutDetails.refNum}`)
    }
  }
  toggleSelectorModal = () => this.setState(state => ({ modalOpen: !state.modalOpen }))
  getAvailableAmendments = () =>
    new Promise((resolve, reject) => {
      GET_DATA_REQUEST_WIZARDS(
        amendments => {
          resolve(amendments)
        },
        err => {
          console.error(err)
          reject(err)
        }
      )
    })
  openAmendment = formDefinitionId => {
    history.push(`/forms/new/${formDefinitionId}`)
  }
  toggleHelpModal = () => {
    this.setState(state =>
      state.drawerType === 'help' && state.drawerOpen
        ? {
            drawerOpen: false
          }
        : {
            drawerType: 'help',
            drawerTitleCache: `${DATA_REQUEST_LABEL ? DATA_REQUEST_LABEL : 'Data Requests'} Help`,
            drawerSubtitleCache: '',
            activeDrawerProps: {},
            drawerOpen: true
          }
    )
  }
  setNicknameById = (dataRequestId, nickname) => {
    this.setState(state => {
      const index = state.requests.findIndex(x => x.DATA_REQUEST_ID === dataRequestId)
      return {
        drawerNicknameCache: nickname ? nickname : state.drawerTitleCache,
        requests: [
          ...state.requests.slice(0, index),
          { ...state.requests[index], NAME_OVERRIDE: nickname },
          ...state.requests.slice(index + 1)
        ]
      }
    })
  }
  handleSidebarDismissed = () => {
    switch (this.state.drawerType) {
      case "help":
        this.toggleHelpModal()
        break;
      case "manage":
      case "downloads":
      default:
        this.setState({drawerOpen: false})
    }
  }
  render() {
    return (
      <Body className="data-requests" showDrawer={!!this.state.drawerOpen}>
        <Toolbar
          title={
            <React.Fragment>
              {DATA_REQUEST_PAGE_TITLE ? `${DATA_REQUEST_PAGE_TITLE}:` : 'Data Requests'}
              <button className="help-button" aria-label="View Help" onClick={this.toggleHelpModal}>
                ?
              </button>
            </React.Fragment>
          }
          underToolbar={DATA_REQUEST_DESCRIPTION ?<p className="description">{DATA_REQUEST_DESCRIPTION}</p> : null}
          className="center-container"
          searchable={false}
          rightAlignChildren={
            <button className="btn btn-primary btn-raised" onClick={this.toggleSelectorModal}>
             {`+ New ${DATA_REQUEST_LABEL ? DATA_REQUEST_LABEL : "Data Request"}`}
            </button>
          }
        />
        <ul className="data-request-blocks">
          {this.state.requests.map(dr => (
            <DataRequestBlock
              {...dr}
              isActive={
                this.state.activeDrawerProps &&
                this.state.activeDrawerProps.id === dr.DATA_REQUEST_ID &&
                this.state.drawerOpen
              }
              onManageClicked={() => this.startManagementDrawer(dr)}
              onDownloadsClicked={() => this.startDownloadsDrawer(dr)}
              onAddToCartClicked={() => this.startCheckout(dr)}
              checkoutOpen={this.state.checkoutOpen}
              key={dr.DATA_REQUEST_ID}
            />
          ))}
        </ul>
        <Portal isOpened={this.state.modalOpen}>
          <Modal
            modalSize="small"
            title={`Select a ${DATA_REQUEST_LABEL ? DATA_REQUEST_LABEL : "Data Request"}`}
            closeButton
            closeModal={this.toggleSelectorModal}
          >
            <AmendmentLauncher
              getAvailableAmendments={this.getAvailableAmendments}
              openAmendment={this.openAmendment}
            />
          </Modal>
        </Portal>
        <Portal isOpened={this.state.checkoutOpen}>
          <SlidingPanel
            closeOnShadeClick={false}
            closeSlider={this.closeCheckout}
            ref={(ref) => {
              this.slider = ref
            }}
          >
            <ConnectedCheckout
              cancelCheckout={this.cancelCheckout}
              closeModal={this.closeCheckout}
              redirectToReceipt={this.openReceipt}
              amendmentNum={this.state.checkoutOpen && this.state.checkoutDetails.amendmentNum}
              refNum={this.state.checkoutOpen && this.state.checkoutDetails.refNum}
              formDefinitionId={
                this.state.checkoutOpen && this.state.checkoutDetails.formDefinitionId
              }
              category='data-request'
              receiptItems={this.state.checkoutOpen && this.state.checkoutDetails.receiptItems}
              receiptItemContainers={
                this.state.checkoutOpen && this.state.checkoutDetails.receiptItemContainers
              }
              onReceiptItemContainerRemoved={() => this.getDataRequests(true)}
            />
          </SlidingPanel>
        </Portal>
        <Drawer
          show={this.state.drawerOpen}
          showCloseButton={true}
          title={this.state.drawerNicknameCache || this.state.drawerTitleCache}
          subtitle={this.state.drawerSubtitleCache}
          onSidebarDismiss={this.handleSidebarDismissed}
          ariaCloseLabel={this.state.drawerType === 'help' ? "Close Help" : "Close"}
        >
          {this.state.drawerType === 'manage' && (
            <ManageDrawer
              formDefinitionId={this.state.activeDrawerProps.formDefinitionId}
              dataRequestId={this.state.activeDrawerProps.id}
              frequencyTypeId={this.state.activeDrawerProps.frequencyTypeId}
              statusId={this.state.activeDrawerProps.statusId}
              canEdit={this.state.activeDrawerProps.canEdit}
              canEditPayment={this.state.activeDrawerProps.canEditPayment}
              canPause={this.state.activeDrawerProps.canPause}
              canUnpause={this.state.activeDrawerProps.canUnpause}
              nickname={this.state.activeDrawerProps.nickname}
              onNicknameChange={nickname =>
                this.setNicknameById(this.state.activeDrawerProps.id, nickname)
              }
              onCanceled={() => this.getDataRequests(true)}
              onPause={() => this.getDataRequests(true)}
              onUnpause={() => this.getDataRequests(true)}
            />
          )}
          {this.state.drawerType === 'downloads' && (
            <ReportsList
              amendmentNum={this.state.activeDrawerProps.id}
              formDefinitionId={this.state.activeDrawerProps.formDefinitionId}
            />
          )}
          {this.state.drawerType === 'help' && <Help />}
        </Drawer>
      </Body>
    )
  }
}

export default connect(null, { setErrorToast })(DataRequests)

let helpCache = null;

const Help = () => {
  const [help, setHelp] = useState(helpCache)
  const [loading, setLoading] = useState(!helpCache);

  useEffect(() => {
    if(!help){
      setLoading(true)
      GET_APP_SETTING_BY_NAME('HELP_ICON_TEXT_DATA_REQUEST', ({ VALUE }) => {
        helpCache = VALUE;
        setHelp(VALUE)
        setLoading(false)
      })
    }
  }, [])

  return (
    loading ?
    <div className="reports-spinner animated fadeIn">
      <Spinner size="medium" themeColor="secondary" />
    </div>
    :
    <Markdown className="markdown" source={help || ''} />
  )
}



// WEBPACK FOOTER //
// ./src/components/DataRequests/DataRequests.js